import PageShell from "@/components/PageShell";

const CONTENT = {
  terms: {
    title: "Kullanım Şartları",
    subtitle: "Coinbuy hizmetlerini kullanarak aşağıdaki şartları kabul etmiş olursunuz.",
    sections: [
      { t: "1. Hizmet Tanımı", d: "Coinbuy, işletmelerin kripto para ile ödeme kabul etmesini sağlayan bir ödeme altyapısı sunar. Ürün ve hizmetler Türk Lirası üzerinden fiyatlandırılır, ödemeler kripto para olarak tahsil edilir." },
      { t: "2. Hesap Sorumluluğu", d: "Hesap güvenliğinizden ve API anahtarlarınızın gizliliğinden siz sorumlusunuz. Şüpheli bir durumda derhal bizimle iletişime geçin." },
      { t: "3. Ücretler ve Komisyonlar", d: "Coinbuy, platform üzerinden gerçekleştirilen başarılı işlemler üzerinden %1 platform hizmet komisyonu tahsil eder. Bekleyen, başarısız veya süresi dolan işlemlerden komisyon alınmaz." },
      { t: "4. Yasak Kullanımlar", d: "Platform yasa dışı faaliyetler, dolandırıcılık veya kara para aklama amacıyla kullanılamaz." },
      { t: "5. Sorumluluk Reddi", d: "Blockchain işlemleri geri alınamaz. Cüzdan adresi ve ağ seçiminden kullanıcı sorumludur." },
    ],
  },
  privacy: {
    title: "Gizlilik Politikası",
    subtitle: "Verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklıyoruz.",
    sections: [
      { t: "Toplanan Veriler", d: "Hesap bilgileri, işlem verileri ve teknik günlükler hizmetin sağlanması amacıyla toplanır." },
      { t: "Veri Kullanımı", d: "Verileriniz yalnızca hizmet sunumu, güvenlik ve yasal yükümlülükler için kullanılır." },
      { t: "Veri Güvenliği", d: "Tüm hassas veriler şifrelenir ve yetkisiz erişime karşı korunur." },
      { t: "Üçüncü Taraflar", d: "Ödeme işleme için gerekli olan hizmet sağlayıcılar dışında verileriniz paylaşılmaz." },
    ],
  },
  refund: {
    title: "İade Politikası",
    subtitle: "Kripto ödemelerde iade süreçleri hakkında bilgilendirme.",
    sections: [
      { t: "Blockchain İşlemleri", d: "Blockchain üzerindeki işlemler geri alınamaz niteliktedir. İade talepleri işletme (merchant) tarafından değerlendirilir." },
      { t: "İade Süreci", d: "İade onaylandığında, ilgili tutar müşterinin belirttiği cüzdan adresine kripto para olarak gönderilir." },
      { t: "Komisyon", d: "İade edilen işlemlerde tahsil edilen platform komisyonu koşullara göre değerlendirilir." },
    ],
  },
  aml: {
    title: "AML Politikası",
    subtitle: "Kara para aklamanın önlenmesine yönelik politikamız.",
    sections: [
      { t: "Uyum", d: "Coinbuy, ilgili kara para aklamayı önleme (AML) düzenlemelerine uyum sağlamayı taahhüt eder." },
      { t: "İzleme", d: "Şüpheli işlemler izlenir ve gerektiğinde ilgili mercilere bildirilir." },
      { t: "Kimlik Doğrulama", d: "Belirli işlem hacimlerinde ek kimlik doğrulaması istenebilir." },
    ],
  },
  risk: {
    title: "Risk Bildirimi",
    subtitle: "Kripto para kullanımına ilişkin riskler hakkında bilgilendirme.",
    sections: [
      { t: "Fiyat Volatilitesi", d: "Kripto para fiyatları yüksek oranda dalgalanabilir. Ödeme anında kur kilitlenir ancak piyasa riski mevcuttur." },
      { t: "Ağ Riskleri", d: "Yanlış ağ veya cüzdan adresi seçimi fon kaybına yol açabilir. İşlem yapmadan önce bilgileri doğrulayın." },
      { t: "Geri Alınamazlık", d: "Onaylanan blockchain işlemleri geri alınamaz." },
    ],
  },
};

export default function LegalPage({ slug }) {
  const c = CONTENT[slug] || CONTENT.terms;
  return (
    <PageShell title={c.title} subtitle={c.subtitle}>
      <div className="space-y-5 max-w-2xl">
        {c.sections.map((s) => (
          <div key={s.t} className="rounded-2xl border border-border bg-card p-6">
            <h3 className="text-base font-bold">{s.t}</h3>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.d}</p>
          </div>
        ))}
      </div>
    </PageShell>
  );
}
